import React from "react";
import { FaRocket, FaLock } from "react-icons/fa";

const WhyUs = () => {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto text-center space-y-16">
        {/* Section Header */}
        <div>
          <p className="text-teal-500 font-semibold uppercase tracking-wide">
            Why Choose Us
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-2">
            Built for teams who value speed, security & support
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto mt-4 text-base">
            TruPay gives you the freedom to move fast, stay secure, and scale
            with confidence. Everything you need to manage payments — and more —
            in one simple platform.
          </p>
        </div>

        {/* Cards */}
        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto text-left">
          {/* Card 1 */}
          <div>
            <h3 className="text-7xl font-extrabold text-gray-900 mb-2">4K+</h3>
            <p className="text-gray-600 text-base">
              Businesses already running smoothly with TruPay’s powerful and
              dependable infrastructure.
            </p>
          </div>

          {/* Card 2 */}
          <div className="relative bg-teal-50 p-6 rounded-lg shadow-sm overflow-hidden min-h-[220px]">
            <h4 className="text-xl font-semibold text-teal-600 mb-2">
              Fast Setup
            </h4>
            <p className="text-gray-700 text-sm">
              Launch your account in minutes. No complex forms or red tape —
              just quick access to your full suite of tools.
            </p>
            <FaRocket className="text-teal-300 text-9xl absolute -bottom-6 -right-6 opacity-40 transform scale-x-[-1]" />
          </div>

          {/* Card 3 */}
          <div className="relative bg-teal-50 p-6 rounded-lg shadow-sm overflow-hidden min-h-[220px]">
            <h4 className="text-xl font-semibold text-teal-600 mb-2">
              Secure Infrastructure
            </h4>
            <p className="text-gray-700 text-sm">
              Built with enterprise-grade encryption, compliance standards, and
              continuous monitoring to protect your data.
            </p>
            <FaLock className="text-teal-300 text-9xl absolute -bottom-6 -right-6 opacity-40" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
